import React from 'react'
import "./styles.scss"
import image from "../../../../assets/images/card_3_htp.png";
import { useTheme } from '../../../../hook/useThemes';


export default function Card3() {
  const {lang} = useTheme()
  return (
    <div className="wrap-cart-how-to-play wrap-cart-how-to-play-3">
      <div className="wrap-title-step">{lang?.step_3 || "Step 3"}</div>
      <p className="label">{lang?.how_to_play_3 || "The market’s closing price determines if your bet was successful.  Good luck!"}</p>
      <img src={image} alt="img" className="image-h_t_play" />
    </div>
  )
}
